meedy.factory('meedy.secondDiagnosisService', ['$q', '$http', '$filter', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
	function ($q, $http, $filter, baseService, objectHelper, config) {
		
		function SecondDiagnosisService() {
			
			this.startWork = function (idSecondDiagnosis) {
				return baseService.post(config.API_URL + '/secondDiagnosis/' + idSecondDiagnosis + '/start').then(
					function (successResponse) {
						return $q.resolve(successResponse);
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};
			
			this.getDataPage = function (criteria) {
				return baseService.post(config.API_URL + '/secondDiagnosis', criteria).then(
					function (successResponse) {
						var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
						dataPage.data = objectHelper.translateArray(dataPage.data, SecondDiagnosisMeedyVO);
						
						return $q.resolve(dataPage);
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};
			
			this.saveOrUpdate = function (idSecondDiagnosis, secondDiagnosisExecutionWrapper) {
				var d = $q.defer();
				
				return baseService.post(config.API_URL + '/secondDiagnosis/' + idSecondDiagnosis, secondDiagnosisExecutionWrapper).then(
					function (successResponse) {
						var data = objectHelper.translateObject(successResponse, SecondDiagnosisMeedyVO);
						
						return $q.resolve(data);
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.refuse = function (idSecondDiagnosis, secondDiagnosisRefusalWrapper) {
				return baseService.post(config.API_URL + '/secondDiagnosis/' + idSecondDiagnosis + '/refuse', secondDiagnosisRefusalWrapper).then(
					function (successResponse) {
						var data = objectHelper.translateObject(successResponse, SecondDiagnosisMeedyVO);

						return $q.resolve(data);
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.refuseIncompetence = function (idSecondDiagnosis, secondDiagnosisRefusalWrapper) {
				return baseService.post(config.API_URL + '/secondDiagnosis/' + idSecondDiagnosis + '/refuseIncompetence', secondDiagnosisRefusalWrapper).then(
					function (successResponse) {
						var data = objectHelper.translateObject(successResponse, SecondDiagnosisMeedyVO);

						return $q.resolve(data);
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};
			
			this.token = function (idSecondDiagnosis) {
				return baseService.get(config.API_URL + '/secondDiagnosis/' + idSecondDiagnosis + '/details/token').then(
					function (successResponse) {
						return $q.resolve(successResponse);
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};
			
			this.downloadPDF = function (token) {
				var d = $q.defer();
				
				$http({
					url: config.API_URL + '/secondDiagnosis/details/download/' + token,
					method: 'GET',
					params: {},
					headers: {
						'Content-type': 'application/pdf'
					},
					responseType: 'arraybuffer'
				}).success(function (data, status, headers, config) {
					var file = new Blob([data], {
						type: 'application/pdf'
					});
					
					var fileURL = URL.createObjectURL(file);
					var a = document.createElement('a');
					a.href = fileURL;
					a.target = '_blank';
					a.download = 'Wywiad Ogólny';
					
					document.body.appendChild(a);
					a.click();
					
					d.resolve(data);
				}).error(function (data, status, headers, config) {
					d.reject(data);
				});
				
				return d.promise;
			};
			
			this.execute = function (idSecondDiagnosis, secondDiagnosisExecutionWrapper) {
				return baseService.post(config.API_URL + '/secondDiagnosis/' + idSecondDiagnosis + '/execute', secondDiagnosisExecutionWrapper).then(
					function (successResponse) {
						var data = objectHelper.translateObject(successResponse, SecondDiagnosisMeedyVO);
						
						return $q.resolve(data);
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};
			
			this.getById = function (idSecondDiagnosis) {
				return baseService.get(config.API_URL + '/secondDiagnosis/' + idSecondDiagnosis).then(
					function (successResponse) {
						var data = objectHelper.translateObject(successResponse, SecondDiagnosisMeedyVO);
						data = objectHelper.convertTimesToDates(data);

						return $q.resolve(data);
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};
			
			
			this.getAttachments = function (idSecondDiagnosis) {
				return baseService.get(config.API_URL + '/secondDiagnosis/' + idSecondDiagnosis + '/attachments').then(
					function (successResponse) {
						var data = objectHelper.translateArray(successResponse, SecondDiagnosisAttachmentMeedyVO);
						return data;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};


			this.downloadSelectedAttachments = function (idSecondDiagnosis, wrapper) {

				return baseService.post(config.API_URL + '/secondDiagnosis/' + idSecondDiagnosis + '/mergedAttachments', wrapper, {responseType: 'arraybuffer'}).then(
					function (successResponse) {
						var blob = new Blob([successResponse], {type: "application/pdf"});
						var pdfLink = (window.URL || window.webkitURL).createObjectURL(blob);

						//window.open(
						//  pdfLink,
						//  '_blank'
						//);

						var ie = navigator.userAgent.match(/MSIE\s([\d.]+)/),
							ie11 = navigator.userAgent.match(/Trident\/7.0/) && navigator.userAgent.match(/rv:11/);

						if (ie || ie11) {
							window.navigator.msSaveBlob(blob, name);

						} else {

							var a = document.createElement('a');
							a.href = pdfLink;
							a.target = '_blank';
							a.download = name;

							document.body.appendChild(a);
							a.click();
						}

						return successResponse;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);

			};
			
			this.downloadAttachment = function (idSecondDiagnosis, idAttachment, name) {
				
				if (name.indexOf('.png') > -1 || name.indexOf('.jpg') > -1) {
					
					return baseService.get(config.API_URL + '/secondDiagnosis/' + idSecondDiagnosis + '/attachment/' + idAttachment, {responseType: 'arraybuffer'}).then(
						function (successResponse) {
							var blob = new Blob([successResponse], {type: "image/jpeg"});
							var pdfLink = (window.URL || window.webkitURL).createObjectURL(blob);
							
							//window.open(
							//  pdfLink,
							//  '_blank'
							//);
							
							var ie = navigator.userAgent.match(/MSIE\s([\d.]+)/),
								ie11 = navigator.userAgent.match(/Trident\/7.0/) && navigator.userAgent.match(/rv:11/);
							
							if (ie || ie11) {
								window.navigator.msSaveBlob(blob, name);
								
							} else {
								
								var a = document.createElement('a');
								a.href = pdfLink;
								a.target = '_blank';
								a.download = name;
								
								document.body.appendChild(a);
								a.click();
							}
							
							return successResponse;
						},
						function (errorResponse) {
							return $q.reject(errorResponse);
						}
					);
					
				} else if (name.indexOf('.pdf')) {

					return baseService.get(config.API_URL + '/secondDiagnosis/' + idSecondDiagnosis + '/attachment/' + idAttachment, {responseType: 'arraybuffer'}).then(
						function (successResponse) {
							var blob = new Blob([successResponse], {type: 'application/pdf'});
							var pdfLink = (window.URL || window.webkitURL).createObjectURL(blob);


							//window.open(
							//  pdfLink,
							//  '_blank'
							//);

							var ie = navigator.userAgent.match(/MSIE\s([\d.]+)/),
								ie11 = navigator.userAgent.match(/Trident\/7.0/) && navigator.userAgent.match(/rv:11/);

							if (ie || ie11) {
								window.navigator.msSaveBlob(blob, name);

							} else {

								var a = document.createElement('a');
								a.href = pdfLink;
								a.target = '_blank';
								a.download = 'Dokument_' + name;

								document.body.appendChild(a);
								a.click();
							}

							return successResponse;
						},
						function (errorResponse) {
							return $q.reject(errorResponse);
						}
					);
					
				}
				
			};
			
		}
		
		return new SecondDiagnosisService();
	}
]);
